import React, { useEffect, useState } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useUserContext } from '../../../context_providers/user_context/UserProvider';
import TransitionWrapper from '../../transition_wrapper/TransitionWrapper';
import { Routes } from '../../../enums/Routes';
import { Box } from '@mui/material';
import { useBannerHeight } from '../../../context_providers/banner_context/BannerHeightContext';

const ProtectedSafeguardRoute = ({
  component: Component,
  requiredPermission,
  ...rest
}) => {
  const { isSafeguardAdmin, isSafeguardManufacturingUser, isSafeguardDev } =
    useUserContext();
  const location = useLocation();
  const { emergencyMapBoxPadding, defaultPageBoxPadding } = useBannerHeight();
  const [paddingToUse, setPaddingToUse] = useState(0);

  useEffect(() => {
    if (location.pathname === '/') {
      setPaddingToUse(emergencyMapBoxPadding);
    } else {
      setPaddingToUse(defaultPageBoxPadding);
    }
  }, [location.pathname, emergencyMapBoxPadding, defaultPageBoxPadding]);

  return (
    <TransitionWrapper>
      <Box component="main" sx={{ pt: paddingToUse }}>
        <Route
          {...rest}
          render={(props) =>
            isSafeguardAdmin ||
            isSafeguardManufacturingUser ||
            isSafeguardDev ? (
              <Component {...props} />
            ) : (
              <Redirect to={Routes.HOME} />
            )
          }
        />
      </Box>
    </TransitionWrapper>
  );
};

export default ProtectedSafeguardRoute;
